/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgentMemoryControllerFindAllQueryResponse, AgentMemoryControllerFindAllQueryParams, AgentMemoryControllerFindAll401, AgentMemoryControllerFindAll403 } from "../../models/agentMemoriesController/AgentMemoryControllerFindAll";

function getAgentMemoryControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/agent-memories` as const }  
  return res
}

/**
 * @summary List accessible AI agent memory profiles
 * {@link /api/v1/agent-memories}
 */
export async function agentMemoryControllerFindAll(params?: AgentMemoryControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AgentMemoryControllerFindAllQueryResponse, ResponseErrorConfig<AgentMemoryControllerFindAll401 | AgentMemoryControllerFindAll403>, unknown>({ method : "GET", url : getAgentMemoryControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}